

// a convenience class that combines properties of FormField and FormInstanceElement
export class FieldValue {
    public fieldId: number;
    public fieldName: string;
    public fieldDisplayName: string;
    public value: string;

    constructor(fieldId: number, fieldName: string, fieldDisplayName: string, value: string) {
        this.fieldId = fieldId;
        this.fieldName = fieldName;
        this.fieldDisplayName = fieldDisplayName;
        this.value = value;
    }

    // Returns fieldName or fieldDisplayName if found in fieldNames, otherwise returns null
    public nameFound(fieldsNames: string[]): string {
        const fieldNameFound = fieldsNames.find(x => { return x == this.fieldName });
        if (fieldNameFound) {
            return fieldNameFound;
        }
        else {
            const displayNameFound = fieldsNames.find(x => { return x == this.fieldDisplayName });
            if (displayNameFound) {
                return displayNameFound;
            } else {
                return null;
            }
        }
    }
}
